export const useTenant = () => {
  const route = useRoute()
  return computed(() => route.params.tenant || 'exchange')
}
